import * as React from "react";
import {useNavigate} from "react-router-dom";
import {JSONCensus} from "../../../processes/massive_actions/CensusCooler/data/models/JSONCensus";

interface DetailDashboardProps {
    lastVisitedCensus: JSONCensus
    navigateToCensusDetail: boolean;
    updateNavigateToCensusDetail: (value: boolean) => void;
}

export const DetailDashboard: React.FC<DetailDashboardProps> = ({
                                                                    lastVisitedCensus,
                                                                    navigateToCensusDetail,
                                                                    updateNavigateToCensusDetail
                                                                }) => {

    const navigate = useNavigate();
    const handlePopState = (event: PopStateEvent) => {
        updateNavigateToCensusDetail(false)
        window.removeEventListener("popstate", handlePopState);
        navigate("/")
    };

    React.useEffect(() => {
        if (navigateToCensusDetail && lastVisitedCensus) {
            window.addEventListener("popstate", handlePopState);
            navigate("/" + lastVisitedCensus.guid, {state: lastVisitedCensus, relative: "route"})
        }
    }, [navigateToCensusDetail]);

    return (
        <div className={"census-empty-page"}></div>
    )
}